import arabicUiCopy from "../../statics/arabicUiCopy";
import React, { useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import localizationStrings from "../../statics/localization";
import CinemaIcon from "../cinema/CinemaIcon";
import { rentalCopy } from "../../api/mw/rental";
import { contentFilterCopy } from "../contentFilter/contentFilterCopy";

export const getSettingsCopy = () =>
  localizationStrings.getLanguage() === "arb" ? arabicUiCopy.settings : localizationStrings.getLanguage() === "tr"
    ? {
        eyebrow: "ATLAS · SANA ÖZEL",
        intro: "İzleme deneyimini kendine göre düzenle.",
        overview: "Genel bakış",
        personal: "Senin Atlas’ın",
        personalNote: "Tercihlerin, tek bir yerde.",
        groups: ["İzleme alanın", "Tercihlerin", "Hesabın"],
        notes: [
          "Sevdiğin kanalları seç, kanal kilitlerini yönet.",
          "Kiraladığın ve satın aldığın içerikleri görüntüle.",
          "Kaydettiğin ve kaydını planladığın yayınlara ulaş.",
          "Ailene uygun izleme tercihlerini düzenle.",
          "Atlas’ı tercih ettiğin dilde kullan.",
          "Üyeliğini, kullanım bilgilerini ve uygulama sürümünü görüntüle.",
          "Hangi duyuruları almak istediğini seç.",
          "Hesabına bağlı cihazları görüntüle ve yönet.",
          rentalCopy().packageNote,
          contentFilterCopy().note
        ],
        emptyPurchase: "Henüz bir işlem yok",
        emptyPurchaseNote:
          "Seçili dönemdeki kiralama ve satın alma işlemlerin burada görünür.",
        period: "Dönem",
        loadError: "Bilgiler yüklenemedi. Lütfen tekrar dene.",
        retry: "Tekrar dene"
      }
    : {
        eyebrow: "ATLAS · MAKE IT YOURS",
        intro: "A viewing experience, shaped around you.",
        overview: "Overview",
        personal: "Your Atlas",
        personalNote: "All your preferences, in one place.",
        groups: ["Your viewing", "Your preferences", "Your account"],
        notes: [
          "Curate your favourites and manage channel locks.",
          "Your rentals and purchases, all in one place.",
          "Revisit saved programmes and upcoming recordings.",
          "Choose the viewing preferences that suit your family.",
          "Make yourself at home in your preferred language.",
          "Your membership, usage and application details.",
          "Choose the updates you want to hear about.",
          "See and manage the devices connected to your account.",
          rentalCopy().packageNote,
          contentFilterCopy().note
        ],
        emptyPurchase: "No transactions yet",
        emptyPurchaseNote:
          "Rentals and purchases for the selected period will appear here.",
        period: "Period",
        loadError: "We couldn’t load these details. Please try again.",
        retry: "Try again"
      };
export const getSettingsItems = () => {
  const c = getSettingsCopy(),
    l = localizationStrings;
  return [
    ["favlockchannel", l.favlockChannel, "heart", 0],
    ["purchasehistory", l.purchaseHistory, "history", 0],
    ["records", l.myRecords, "library", 0],
    ["parentalcontrol", l.parentalControl, "shield", 1],
    ["language", l.menuLanguage, "globe", 1],
    ["version", l.versionAndUser, "user", 2],
    ["notifications", l.notificationsSettings, "bell", 1],
    ["devices", l.deviceManagement, "devices", 2],
    ["package", rentalCopy().packages, "library", 2],
    ["contentfilter", contentFilterCopy().title, "sliders", 1]
  ].map(([id, title, icon, group], index) => ({
    id,
    title,
    icon,
    group,
    note: c.notes[index],
    path: `/dashboard/${id}`
  }));
};

export default function SettingsFrame({ children }) {
  const { pathname } = useLocation(),
    copy = getSettingsCopy(),
    items = getSettingsItems();
  const item = items.find((entry) => entry.path === pathname),
    overview = pathname === "/dashboard/settings",
    active = overview || !!item;
  useEffect(() => {
    if (!active) return;
    document.body.classList.add("atlas-settings-open");
    window.scrollTo(0, 0);
    return () => document.body.classList.remove("atlas-settings-open");
  }, [active, pathname]);
  if (!active) return children;
  return (
    <section className="atlas-settings">
      <header className="settings-page-heading">
        <div>
          <span className="settings-eyebrow">{copy.eyebrow}</span>
          <h1>{overview ? localizationStrings.settings : item.title}</h1>
          <p>{overview ? copy.intro : item.note}</p>
        </div>
        <Link
          className="settings-back-link"
          to={overview ? "/dashboard/home/home/all" : "/dashboard/settings"}
        >
          <CinemaIcon name="previous" />
          {overview ? localizationStrings.home : localizationStrings.settings}
        </Link>
      </header>
      <div className="settings-layout">
        <aside className="settings-sidebar">
          <div className="settings-personal">
            <span>
              <CinemaIcon name="sliders" />
            </span>
            <div>
              <strong>{copy.personal}</strong>
              <p>{copy.personalNote}</p>
            </div>
          </div>
          <nav aria-label={localizationStrings.settings}>
            <NavLink exact to="/dashboard/settings" activeClassName="is-active">
              <CinemaIcon name="sliders" />
              {copy.overview}
            </NavLink>
            {copy.groups.map((group, index) => (
              <div className="settings-nav-group" key={group}>
                <span>{group}</span>
                {items
                  .filter((entry) => entry.group === index)
                  .map((entry) => (
                    <NavLink
                      key={entry.id}
                      to={entry.path}
                      activeClassName="is-active"
                    >
                      <CinemaIcon name={entry.icon} />
                      <span>{entry.title}</span>
                    </NavLink>
                  ))}
              </div>
            ))}
          </nav>
        </aside>
        <main className="settings-page-content" key={pathname}>
          {children}
        </main>
      </div>
    </section>
  );
}
